import React, { useContext, useEffect, useState } from 'react';
import Dialog from '../../../../../components/Dialog/YesNo';
import { store } from './reducer';
import { store as mainStore } from '../../../../../store';
import axios from '../../../../../api/axios';
import Circular from '../../../../../components/Progress/Circular';
import { makeStyles } from '@material-ui/core/styles';
import formatNumber from '../../../../../fns/formatNumber';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
    '& > *': {
      fontSize: 18,
    },
  },
}));

const WalletDialog = ({ open, payment, userId, orderId, credit }) => {
  const classes = useStyles();
  const {
    state: { selectedPayment },
    dispatch,
    refresh,
  } = useContext(store);
  const { showMessage, showError } = useContext(mainStore);
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = async (agree) => {
    if (agree) {
      setLoading(true);
      const { data } = await axios.post(`/api/v1/admin/users/creditDeduction`, {
        userId,
        description: 'کسر کمیسیون از کیف پول',
        amount: payment,
        order: orderId,
        transactionType: 'pay_commission',
      });
      if (data.ok) {
        refresh();
        showMessage(data.messages);
      }
    }
    setLoading(false);
    dispatch({ type: 'CLOSE_PAYMENT_DIALOG' });
  };

  return (
    <Dialog
      title="پراخت از کیف پول کاربر"
      yes="انجام"
      no="صرفنظر"
      open={open}
      onClose={handleCloseDialog}
      startIcon
      inProgress={loading}
    >
      {credit === null ? (
        <Circular text="درحال محاسبه..." />
      ) : (
        <div className={classes.root}>
          <div>موجودی قبل کسر پول: {formatNumber(credit)} تومان</div>
          <div>- مبلغ پرداختنی: {formatNumber(payment)} تومان</div>
          <div>
            = موجودی پس از کسر پول: {formatNumber(credit - payment)} تومان
          </div>
          {credit < payment && (
            <Alert variant="standard" color="error" icon={false}>
              موجودی کیف پول کمتر از مبلغ پرداختنی است و کاربر بدهکار خواهد شد
            </Alert>
          )}
        </div>
      )}
    </Dialog>
  );
};

export default React.memo(WalletDialog);
